import Cookies from 'universal-cookie'
const cookies = new Cookies()

let session = cookies.get('iSense_user') ? cookies.get('iSense_user') : []

const menuAdmin = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Management User',
    to: '/managementusers',
    icon: 'cil-user'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Instalation Result',
    to: '/instalationresult',
    icon: 'cil-laptop'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CUSTOMER']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Management Customers',
    to: '/management-customers',
    icon: 'cil-people'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CCC']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'CCC Dashboard',
    route: '/#',
    icon: 'cil-speedometer',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'New Ticket',
        to: '/ticket/new',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Ready to Reserved',
        to: '/ticket/readyreserved',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Progress',
        to: '/ticket/progress',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Reporting',
        to: '/ticket/report',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Close Ticket',
        to: '/ticket/close',
      }
    ],
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Upload DS',
    to: '/uploadds',
    icon: 'cilFile'
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Consumable',
    route: '/consumable',
    icon: 'cil-chartPie',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable EDS',
        to: '/searchconsumable',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable GCS',
        to: '/searchconsumablegcs',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable EDS',
        to: '/chartstatustoner',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable GCS',
        to: '/chartstatustonergcs',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search SN Toner & Drum',
        to: '/searchsn',
        // icon: 'cil-chartPie'
      },
    ],
  },
]

const menuSA = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CUSTOMER']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Management Customers',
    to: '/management-customers',
    icon: 'cil-people'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Consumable',
    route: '/consumable',
    icon: 'cil-chartPie',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable EDS',
        to: '/searchconsumable',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable GCS',
        to: '/searchconsumablegcs',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable EDS',
        to: '/chartstatustoner',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable GCS',
        to: '/chartstatustonergcs',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search SN Toner & Drum',
        to: '/searchsn',
        // icon: 'cil-chartPie'
      },
    ],
  },
]

const menuCCC = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CCC']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'CCC Dashboard',
    route: '/#',
    icon: 'cil-speedometer',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'New Ticket',
        to: '/ticket/new',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Ready to Reserved',
        to: '/ticket/readyreserved',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Progress',
        to: '/ticket/progress',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Reporting',
        to: '/ticket/report',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Close Ticket',
        to: '/ticket/close',
      }
    ],
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Consumable',
    route: '/consumable',
    icon: 'cil-chartPie',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable EDS',
        to: '/searchconsumable',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable GCS',
        to: '/searchconsumablegcs',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable EDS',
        to: '/chartstatustoner',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable GCS',
        to: '/chartstatustonergcs',
        // icon: 'cil-chartPie'
      },
    ],
  },
]
const menuCSM = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Instalation Result',
    to: '/instalationresult',
    icon: 'cil-laptop'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CUSTOMER']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Management Customers',
    to: '/management-customers',
    icon: 'cil-people'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Consumable',
    route: '/consumable',
    icon: 'cil-chartPie',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable EDS',
        to: '/searchconsumable',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable GCS',
        to: '/searchconsumablegcs',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable EDS',
        to: '/chartstatustoner',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable GCS',
        to: '/chartstatustonergcs',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search SN Toner & Drum',
        to: '/searchsn',
        // icon: 'cil-chartPie'
      },
    ],
  },
]
const menuSDM = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Consumable',
    route: '/consumable',
    icon: 'cil-chartPie',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable EDS',
        to: '/searchconsumable',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Data Consumable GCS',
        to: '/searchconsumablegcs',
        // icon: 'cil-calculator'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable EDS',
        to: '/chartstatustoner',
        // icon: 'cil-chartPie'
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'History Consumable GCS',
        to: '/chartstatustonergcs',
        // icon: 'cil-chartPie'
      },
    ],
  },
]

const menuBM = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CUSTOMER']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Management Customers',
    to: '/management-customers',
    icon: 'cil-people'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
]

const menuCustomer = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Download iSense Installer',
  //   target: "_blank",
  //   href: 'https://tinyurl.com/NewiSense4',
  //   icon: 'cil-cloud-download'
  // },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
]

const menuCE = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Instalation Result',
    to: '/instalationresult',
    icon: 'cil-laptop'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['CUSTOMER']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Management Customers',
    to: '/management-customers',
    icon: 'cil-people'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  }
]

const menuOther = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Download iSense Installer',
    target: "_blank",
    href: 'https://tinyurl.com/NewiSense4',
    icon: 'cil-cloud-download'
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['DEVICE']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Device',
    route: '/device',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'EDS DEVICE',
        to: '/deviceeds',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'GCS Device',
        to: '/devicegcs',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Search Device',
        to: '/devicesearch',
      }
    ],
  },
]

let Mmenu = ''
if (session.account_type == 'Admin') {
  Mmenu = menuAdmin
} else if (session.account_type == 'SA') {
  Mmenu = menuSA
} else if (session.account_type == 'CCC') {
  Mmenu = menuCCC
} else if (session.account_type == 'CSM') {
  Mmenu = menuCSM
} else if (session.account_type == 'SDM') {
  Mmenu = menuSDM
} else if (session.account_type == 'BM') {
  Mmenu = menuBM
} else if (session.account_type == 'Customer') {
  Mmenu = menuCustomer
} else if (session.account_type == 'CE') {
  Mmenu = menuCE
} else {
  Mmenu = menuOther
}

export default Mmenu

